<template>
  <el-dialog title="坏件库汇总" :visible.sync="dialogFormVisible" custom-class="full-dialog" center
             :close-on-click-modal="false" :append-to-body="true">
  <div>
    <div class="search-content">
      <el-col :span="24" class="toobar">
        <el-row>
          <el-col :span="3">
            <el-input placeholder="请选择商品" v-model="seedname" clearable @click.native="showGoodDetailSel" size="mini"
                      @clear="clearSeedCode">
            </el-input>
          </el-col>
          <el-col :span="19">
            <el-select v-model="cangkucode" @change="bindGrid" filterable style="width: 150px" size="mini">
              <el-option v-for="item in jxcstoreData" :key="item.cangkucode"
                         :label="item.cangkuname"
                         :value="item.cangkucode">
              </el-option>
            </el-select>
            <el-select v-model="selectedFillTemplate" @change="bindGrid" filterable clearable
                       placeholder="品类" size="mini" style="width: 120px; margin-left: 10px">
              <el-option v-for="item in filltemplateOptions" :key="item.value"
                         :label="item.label" :value="item.value"/>
            </el-select>
            <el-select v-model="selectedBrandCodes" @change="bindGrid" multiple collapse-tags
                       filterable clearable placeholder="品牌" size="mini" style="width: 220px; margin-left: 10px">
              <el-option v-for="item in brandList" :key="item.categorycode"
                         :label="item.categoryname" :value="item.categorycode"/>
            </el-select>
            <el-input style="width:180px;" size="mini"
                      placeholder="输入销售单号或采购单号"
                      prefix-icon="el-icon-search"
                      v-model="searchdata" clearable>
            </el-input>
            <el-date-picker v-model="date" size="mini" type="month" style="width:120px;" :clearable="false" placeholder="选择日期"></el-date-picker>
            <el-button type="primary" v-model="searchdata" icon="el-icon-search" size="mini" @click="bindGrid(false)">搜索</el-button>
            <el-button @click="excelPort" type="warning" size="mini">导出</el-button>
          </el-col>
        </el-row>
      </el-col>
    </div>
    <el-table
      :data="tableData"
      :height="eltableheight"
      size="mini"
      stripe
      border
      show-summary
      :summary-method="getSummaries"
      style="width: 100%;">
      <el-table-column
        width="50"
        label="序号" fixed
        align="center">
        <template slot-scope="scope">
          {{1+scope.$index}}
        </template>
      </el-table-column>
      <el-table-column
        prop="cangkuname"
        label="仓库" fixed
        header-align="center"
        :show-overflow-tooltip="true"
        align="left"
        width="100">
      </el-table-column>
      <el-table-column
        prop="CategoryName" width="80"
        label="品牌" fixed
        header-align="center"
        :show-overflow-tooltip="true"
        align="left">
      </el-table-column>
      <el-table-column
        label="品类"
        width="80"
        header-align="center"
        align="center">
        <template slot-scope="scope">
          {{ formatFillTemplate(scope.row.FillTemplate) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="seedname"
        label="名称" fixed  width="160"
        header-align="center"
        :show-overflow-tooltip="true"
        align="left">
      </el-table-column>
      <el-table-column
        prop="seedcode"
        label="编码"
        header-align="center"
        width="90"
        :show-overflow-tooltip="true"
        align="left">
      </el-table-column>
      <el-table-column   label="入库量"  header-align="center">
      <el-table-column
        prop="tuihuo"
        label="销售退货"
        header-align="center"
        align="center"
        width="75" >
      </el-table-column>
      <el-table-column
        prop="zhuanru"
        label="正式转出"
        header-align="center"
        align="center"
        width="75" >
      </el-table-column>
      <el-table-column
        prop="zhiliang"
        label="质检问题"
        header-align="center"
        align="center"
        width="75" >
      </el-table-column>
      <el-table-column
        prop="jiagongbaosun"
        label="加工损坏"
        header-align="center"
        align="center"
        width="75" >
      </el-table-column>
      <el-table-column
        prop="duofa"
        label="供应商多发"
        header-align="center"
        align="center"
        width="90" >
      </el-table-column>
      </el-table-column>
      <el-table-column   label="已处理合计"  header-align="center">
        <template v-if="isFinancial">
          <el-table-column
            label="退回供应商"
            header-align="center"
            align="center">
            <el-table-column
              prop="thgys"
              label="数量"
              header-align="center"
              align="right"
              width="100" >
              <template slot-scope="scope">
                {{scope.row.thgys|numeric(0)}}
              </template>
            </el-table-column>
            <el-table-column
              prop="thgysprice"
              label="单价"
              header-align="center"
              align="right"
              width="100" >
              <template slot-scope="scope">
                {{scope.row.thgysprice|numeric(2)}}
              </template>
            </el-table-column>
            <el-table-column
              prop="thgysmoney"
              label="总额"
              header-align="center"
              align="right"
              width="100" >
              <template slot-scope="scope">
                {{scope.row.thgysmoney|numeric(2)}}
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column
            label="损耗"
            header-align="center"
            align="center">
            <el-table-column
              prop="sunhao"
              label="数量"
              header-align="center"
              align="right"
              width="100" >
              <template slot-scope="scope">
                {{scope.row.sunhao|numeric(0)}}
              </template>
            </el-table-column>
            <el-table-column
              prop="sunhaoprice"
              label="单价"
              header-align="center"
              align="right"
              width="100" >
              <template slot-scope="scope">
                {{scope.row.sunhaoprice|numeric(2)}}
              </template>
            </el-table-column>
            <el-table-column
              prop="sunhaomoney"
              label="总额"
              header-align="center"
              align="right"
              width="100" >
              <template slot-scope="scope">
                {{scope.row.sunhaomoney|numeric(2)}}
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column
            label="转入正式库"
            header-align="center"
            align="right">
            <el-table-column
              prop="ruzhnegshiku"
              label="数量"
              header-align="center"
              align="right"
              width="100" >
              <template slot-scope="scope">
                {{scope.row.ruzhnegshiku|numeric(0)}}
              </template>
            </el-table-column>
            <el-table-column
              prop="ruzhnegshikuprice"
              label="单价"
              header-align="center"
              align="right"
              width="100" >
              <template slot-scope="scope">
                {{scope.row.ruzhnegshikuprice|numeric(2)}}
              </template>
            </el-table-column>
            <el-table-column
              prop="ruzhnegshikumoney"
              label="总额"
              header-align="center"
              align="right"
              width="100" >
              <template slot-scope="scope">
                {{scope.row.ruzhnegshikumoney|numeric(2)}}
              </template>
            </el-table-column>
          </el-table-column>
        </template>
       <template v-else>
         <el-table-column
           label="退回供应商"
           header-align="center"
           align="center">
             <template slot-scope="scope">
               {{scope.row.thgys|numeric(0)}}
             </template>
         </el-table-column>
         <el-table-column
           label="损耗"
           header-align="center"
           align="center">
             <template slot-scope="scope">
               {{scope.row.sunhao|numeric(0)}}
             </template>
         </el-table-column>
         <el-table-column
           label="转入正式库"
           header-align="center"
           align="right">
             <template slot-scope="scope">
               {{scope.row.ruzhnegshiku|numeric(0)}}
             </template>
         </el-table-column>
       </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="80" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="lookorder(scope.row)">查看
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <StorageBadDetail ref="StorageBadDetail" @bindGrid="bindGrid"></StorageBadDetail>
    <JxcgooddetailSel ref="JxcgooddetailSel" @afterSelectCode="afterSelectCode"></JxcgooddetailSel>
  </div>
  </el-dialog>
</template>

<script>
  import {independentDept} from '@/api/set/dept';
  import {brokengoodslist, badpartsimport, badpartslist} from '@/api/set/warehouse'
  import {listLens} from '@/api/set/jxcgoodscategory'
  import StorageBadDetail from './StorageBadDetail';
  import {cusandptbyind} from '@/api/set/jxcstore';
  import {completedcount} from '@/api/set/jxcstoreformdetail';
  import JxcgooddetailSel from '../set/jxcgooddetail/JxcgooddetailSel'

  export default {
    name: 'StorageBadSummary',
    data() {
      return {
        msg:'坏件库汇总页',
        isFinancial:false,
        eltableheight:'300',
        userInfoModel: {},
        dialogFormVisible: false,
        searchdata: "",
        loading: true,
        independentserial: "",
        jxcstoreData:[],
        tableData: [],
        cangkucode: '',
        handlemode: '',
        canshowgoodsel:true,
        seedname: '',
        seedcode: '',
        date: '',
        selectedFillTemplate: "",
        filltemplateOptions: [
          { label: "镜片", value: "10,20" },
          { label: "现片", value: "10" },
          { label: "定制", value: "20" },
          { label: "加工", value: "50" },
          { label: "镜架", value: "80" },
          { label: "其他", value: "40" }
        ],
        selectedBrandCodes: [],
        brandList: []
      }
    },
    props: {
      cangkucodes: {type: Array, default: () => []},
      cangkuname: {default: ""},
    },
    methods: {
      loadBrandList() {
        listLens({ enable: 1 }).then(res => {
          this.brandList = res.data.obj || []
        })
      },
      formatFillTemplate(val) {
        if (val === '10' || val === '20' || val === 10 || val === 20) return '镜片'
        if (val === '50' || val === 50) return '加工'
        if (val === '80' || val === 80) return '镜架'
        if (val === '40' || val === 40) return '其他'
        return val || ''
      },
      buildFilterParams() {
        const params = {}
        if (this.selectedFillTemplate) params.filltemplate = this.selectedFillTemplate
        if (this.selectedBrandCodes.length > 0) params.categorycode = this.selectedBrandCodes.join(",")
        return params
      },
      show(searchdata){
        this.jxcstoreData=searchdata.jxcstoreData;
        this.cangkucode=searchdata.cangkucode;
        this.seedname=searchdata.seedname;
        this.seedcode=searchdata.seedcode;
        this.searchdata=searchdata.searchdata;
        this.date=searchdata.date;
        // 继承父组件的品类/品牌筛选
        this.selectedFillTemplate = searchdata.selectedFillTemplate || ""
        this.selectedBrandCodes = searchdata.selectedBrandCodes || []
        this.bindGrid();
        this.dialogFormVisible=true;
      },
      //导出
      excelPort() {
        var data = this.tableData.map(item => {
          return { ...item, pinpai: this.formatFillTemplate(item.FillTemplate) }
        })

        var date = new Date();
        var y = 1900 + date.getYear();
        var m = "0" + (date.getMonth() + 1);
        var d = "0" + date.getDate();
        let header1 = ["仓库", "品牌", "名称", "编码", "品类", "销售退货", "正式转出", "质量问题", "加工损坏", "供应商多发", "退回供应商数量", "采购单价", "采购退款总额", "报损数量", "报损单价", "报损总额", "转回正式库", "存货单价", "转回正式库总额"]
        let column1 = ["cangkuname", "CategoryName", "seedname", "seedcode", "pinpai", "tuihuo", "zhuanru", "zhiliang", "jiagongbaosun", "duofa", "thgys", "thgysprice", "thgysmoney", "sunhao", "sunhaoprice", "sunhaomoney", "ruzhnegshiku", "ruzhnegshikuprice", "ruzhnegshikumoney"]
        if (!this.isFinancial) {
          let header1 = ["仓库", "品牌", "名称", "编码", "品类", "销售退货", "正式转出", "质量问题", "加工损坏", "供应商多发", "退回供应商数量","报损数量", "转回正式库"]
          let column1 = ["cangkuname", "CategoryName", "seedname", "seedcode", "pinpai", "tuihuo", "zhuanru", "zhiliang", "jiagongbaosun", "duofa", "thgys",  "sunhao",  "ruzhnegshiku"]

        }
        var name = '坏件库变动情况汇总' + y + m.substring(m.length - 2, m.length) + d.substring(d.length - 2, d.length)
        this.$exportExcel(header1, column1, data, name)
      },
      //显示商品选择页面
      showGoodDetailSel() {
        if (this.canshowgoodsel) {
          this.$refs.JxcgooddetailSel.show()
        } else {
          this.canshowgoodsel = true
        }
      },
      //清空商品
      clearSeedCode() {
        this.seedcode = ""
        this.seedname = ""
        this.canshowgoodsel = false
        this.bindGrid()
      },
      //选择商品之后执行
      afterSelectCode(row) {
        this.seedcode = row.seedcode
        this.seedname = row.seedname
        this.bindGrid()
      },
      //合计
      getSummaries(param) {
        const {columns, data} = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '合计';
            return;
          }
          if (index <= 4 || (column.property && column.property.indexOf('price') > -1)) {
            sums[index] = '';
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            if (sums[index] && sums[index] > 0) {
              if (column.property.indexOf('money') > -1)
                sums[index] = parseFloat(sums[index]).toFixed(2);
            }
          } else {
            sums[index] = '';
          }
        });

        return sums;
      },
      getPackagesize(packagesize) {
        let s = ""
        if (packagesize) {
          let temp = JSON.parse(packagesize)
          if (temp.M) {
            s = temp.M + '-' + temp.C;
          } else {
            s = "S:" + (parseFloat(temp.Y) > 0 ? "+" + temp.Y : temp.Y) + ",C:" + (parseFloat(temp.X) > 0 ? "+" + temp.X : temp.X)
          }
        }
        return s
      },
      lookorder(row) {
        this.$refs.StorageBadDetail.initData(row, this.searchdata,this.date,this.jxcstoreData)
      },
      bindGrid() {
        this.tableData = []
        if (!this.date)
          this.setNow();
        var SelDate = new Date(this.date)
        completedcount(Object.assign({
          cangkucode: this.cangkucode,
          search: this.searchdata,
          seedcode: this.seedcode,
          yearflag: SelDate.getFullYear(),
          monthflag: SelDate.getMonth() + 1,
        }, this.buildFilterParams())).then(response => {
          var tHeight=this.tableHeight(115);
          this.eltableheight = this.eltableheight==tHeight?(tHeight-1):tHeight;

          var dt = response.data.obj;
          for (let i in dt) {
            if (dt[i].thgys && dt[i].thgys > 0) {
              dt[i].thgysmoney = parseFloat(dt[i].thgys) * parseFloat(dt[i].thgysprice);
            }
            if (dt[i].ruzhnegshiku && dt[i].ruzhnegshiku > 0) {
              dt[i].ruzhnegshikumoney = parseFloat(dt[i].ruzhnegshiku) * parseFloat(dt[i].ruzhnegshikuprice);
            }

            if (dt[i].sunhao && dt[i].sunhao > 0) {
              var costP = dt[i].CostPrice;
              if (dt[i].thgysprice && parseFloat(dt[i].thgysprice) > 0) {
                costP = dt[i].thgysprice;
              }
              if (dt[i].ruzhnegshikuprice && parseFloat(dt[i].ruzhnegshikuprice) > 0) {
                costP = dt[i].ruzhnegshikuprice;
              }
              dt[i].sunhaoprice = costP;
              dt[i].sunhaomoney = parseFloat(dt[i].sunhao) * parseFloat(costP);
            }
          }
          this.tableData = dt;
          this.clearZero();
        })
      },
      clearZero(){
        var colms='tuihuo;zhuanru;zhiliang;jiagongbaosun;duofa;thgys;sunhao;ruzhnegshiku'.split(';')
        for(let i=0;i<this.tableData.length;i++) {
          for (let j = 0; j < colms.length; j++) {
            if(this.tableData[i][colms[j]]==0)
              this.tableData[i][colms[j]]=null;
          }
        }
      },
      //根据登录人过滤仓库
      cusandptbyind() {
        cusandptbyind({}).then(response => {
          this.jxcstoreData = response.data.obj
          this.cangkucode= this.jxcstoreData[0].cangkucode
          //默认仓库
          if (this.userInfoModel.cangku) {
            let temp1 = this.userInfoModel.cangku.split(";")
            biaoji:
              for (let i in temp1) {
                for (let j in  this.jxcstoreData) {
                  if (temp1[i] == this.jxcstoreData[j].cangkucode) {
                    this.cangkucode = temp1[i]
                    break biaoji;
                  }
                }
              }

          }
          if (this.userInfoModel.independentserial == "") {//总部登录
            this.jxcstoreData.unshift({
              cangkuname: "全部仓库",
              cangkucode: ''
            })
          }
          this.bindGrid();
        })

      },
      setNow(){
        this.date=new Date()
      }
    },
    mounted() {
      this.isFinancial = this.$checkRight("财务");
      this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
      //默认值
      this.independentserial = this.userInfoModel.independentserial;
      this.setNow();
      this.loadBrandList();

      //绑定仓库,绑定列表数据
      this.cusandptbyind()
    },
    components: {
      StorageBadDetail,
      JxcgooddetailSel
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/warehouse/StorageBadSummary.vue